<template>
  <NostoCarouselHelper
    v-if="nostoProductRecommendations.length > 0"
    v-slot="{ products }"
    :recommendations="nostoProductRecommendations"
    :placement-id="nostoProductRecommendationsProductId"
  >
    <HomepageProductCarousel
      :title="title"
      :subtitle="subtitle"
      :link="link"
      :products="products"
      :slide-width="slideWidth"
      :slide-width-tablet="slideWidthTablet"
      :slide-width-desktop="slideWidthDesktop"
    />
  </NostoCarouselHelper>
  <CollectionCarouselHelper
    v-else-if="collectionHandle"
    v-slot="{ products }"
    :collection-handle="collectionHandle"
  >
    <HomepageProductCarousel
      :title="title"
      :subtitle="subtitle"
      :link="link"
      :products="products"
      slide-width="310px"
      slide-width-tablet="310px"
      slide-width-desktop="300px"
    />
  </CollectionCarouselHelper>
</template>

<script>
import NostoCarouselHelper from "@/components/NostoCarouselHelper.vue";
import CollectionCarouselHelper from "@/components/CollectionCarouselHelper.vue";
import HomepageProductCarousel from "@/components/homepage/HomepageProductCarousel.vue";

export default {
  name: "HomepageRecommendationsCarousel",
  components: {
    NostoCarouselHelper,
    HomepageProductCarousel,
    CollectionCarouselHelper,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    subtitle: {
      type: String,
      required: true,
    },
    link: {
      type: String,
      default: null,
    },
    slideWidth: {
      type: String,
      default: "200px",
    },
    slideWidthTablet: {
      type: String,
      default: "260px",
    },
    slideWidthDesktop: {
      type: String,
      default: "300px",
    },
    collectionHandle: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      nostoProductRecommendations: [],
      nostoProductRecommendationsProductId: null,
    };
  },
  created() {
    // eslint-disable-next-line no-undef
    nostojs((api) => {
      api
        .defaultSession()
        .viewFrontPage()
        .setPlacements(["frontpage-nosto-1"])
        .load()
        .then((data) => {
          this.nostoProductRecommendations =
            data.recommendations["frontpage-nosto-1"]?.products || null;
          this.nostoProductRecommendationsProductId =
            data.recommendations["frontpage-nosto-1"]?.result_id || null;
        });
    });
  },
};
</script>
